import React, { useState } from 'react';
import { Navbar, Container, Dropdown, Image } from 'react-bootstrap';
import { PersonFill, BoxArrowRight, List } from 'react-bootstrap-icons';
import { useAuth } from '../../AuthContext';
import logo from '../../assets/img/logo-conduto.png';
import './Navbar.css';

const CustomNavbar = ({ onToggleSidebar, username = "Usuario" }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const { logout, user } = useAuth();

  const handleLogoutClick = async (e) => {
    e.preventDefault();
    try {
      await logout();
    } catch (error) {
      console.error('Error durante el logout:', error);
    }
  };

  const handleProfileClick = () => {
    const path =
      user?.rol === 'administrador' || user?.rol === 'superusuario'
        ? '/administrador/perfil'
        : '/perfil';

    window.location.href = `${process.env.PUBLIC_URL}${path}`;
  };

  const handleProveedorClick = () => {
    window.location.href = `${process.env.PUBLIC_URL}`;
  };

  return (
    <Navbar bg="white" variant="light" fixed="top" className="shadow-sm py-2">
      <Container fluid>
        <div className="d-flex align-items-center">
          {onToggleSidebar && (
            <button
              className="btn btn-link me-3 sidebar-toggle"
              onClick={onToggleSidebar}
              aria-label="Toggle sidebar"
            >
              <List size={24} />
            </button>
          )}

          <button
            className="btn btn-link p-0 me-2"
            onClick={handleProveedorClick}
            aria-label="Ir a Proveedor"
            style={{ background: 'none', border: 'none' }}
          >
            <Image
              src={logo}
              alt="Logo Empresa"
              height="16"
              width="auto"
              style={{ maxHeight: '36px', width: 'auto' }}
              className="d-inline-block align-top"
              fluid
            />
          </button>
        </div>

        <div className="d-flex align-items-center">
          <Dropdown
            align="end"
            show={showDropdown}
            onToggle={setShowDropdown}
            className="user-dropdown"
          >
            <Dropdown.Toggle
              as="div"
              className="profile-toggle d-flex align-items-center"
              aria-label="Menú de usuario"
            >
              <div className="profile-icon d-flex justify-content-center align-items-center me-2">
                <PersonFill size={20} />
              </div>
              <span className="username d-none d-md-inline">{username}</span>
            </Dropdown.Toggle>

            <Dropdown.Menu className="dropdown-menu-end shadow">
              {(user?.rol === 'administrador' || user?.rol === 'superusuario') && (
                <Dropdown.Item as="button" onClick={handleProfileClick}>
                  <PersonFill className="me-2" />
                  Ver perfil
                </Dropdown.Item>
              )}

              <Dropdown.Item
                as="button"
                onClick={handleLogoutClick}
                className="text-danger"
              >
                <BoxArrowRight className="me-2" />
                Cerrar sesión
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
